module.exports = __webpack_public_path__ + "img/icon-08-subscriptionAsset 14.21318529.svg";